import {
    ArrowBackIosRounded,
    ArrowForwardIosRounded,
    ChevronLeftRounded,
    ChevronRightRounded,
    RedoRounded,
    UndoRounded,
} from '@mui/icons-material';
import { IconProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

function UndoIcon(props: IconProps) {
    const { i18n } = useTranslation();
    const rtl = i18n.dir() === 'rtl';

    const IconComponent = rtl ? RedoRounded : UndoRounded;
    return <IconComponent {...props} />;
}

function RedoIcon(props: IconProps) {
    const { i18n } = useTranslation();
    const rtl = i18n.dir() === 'rtl';

    const IconComponent = rtl ? UndoRounded : RedoRounded;
    return <IconComponent {...props} />;
}

function ArrowBackIosIcon(props: IconProps) {
    const { i18n } = useTranslation();
    const rtl = i18n.dir() === 'rtl';

    const IconComponent = rtl ? ArrowForwardIosRounded : ArrowBackIosRounded;
    return <IconComponent {...props} />;
}

function ChevronLeftIcon(props: IconProps) {
    const { i18n } = useTranslation();
    const rtl = i18n.dir() === 'rtl';

    const IconComponent = rtl ? ChevronRightRounded : ChevronLeftRounded;
    return <IconComponent {...props} />;
}

export { UndoIcon, RedoIcon, ArrowBackIosIcon, ChevronLeftIcon };
